module.exports = __webpack_public_path__ + "static/img/green-jh.89015b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/green-jh.png
// module id = 8CQ5
// module chunks = 1